import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from 'react-query';
import { infobankTypes } from 'common/data/InfoBankTypes';
import { addInfoBankNewInformation } from 'helpers/fakebackend_helper';
import * as Yup from 'yup';




const InfoCreateFrom = ({ onClose }) => {

  const queryClient = useQueryClient();
  const { mutate: addInformationMutate, isLoading: isAddInformationLoading } = useMutation(addInfoBankNewInformation);


  const addInformation = (values, { resetForm }) => {
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('content', values.content);
    formData.append('info_type', values.infoType);
    formData.append('item_type', 'text');


    addInformationMutate(formData, {
      onSuccess: () => {
        queryClient.invalidateQueries('infoBank');
        resetForm();  
        onClose()
      }
    });
  };

  const contactSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    content: Yup.string().required('Content is required'),
    infoType: Yup.string().required('Information type is required'),
  });



  return (
    <Formik
    initialValues={{ name: '', content: '', infoType: '' }}
    validationSchema={contactSchema}
    onSubmit={addInformation}
  >
    {({ values, handleChange }) => (
      <Form id='add-new-info'>
        <h5 className="mb-4">Add New Information</h5>
        <div className="d-flex justify-content-between mb-2">
          <label className="mr-2">Information Type:</label>
          <Field as="select" name="infoType" style={{ width: '50%' }} className="form-control">
            <option value="" disabled>Select Information Type</option>
            {infobankTypes.map((type, index) => (
              <option key={index} value={type}>{type}</option>
            ))}
          </Field>
          {/* <ErrorMessage name="infoType" component="div" className="text-danger" /> */}
        </div>
        <div className="d-flex justify-content-between mb-2">
          <label className="mr-2">Information Name:</label>
          <Field
            name="name"
            placeholder="Information Name"
            style={{ width: '50%' }}
            className="form-control"
          />
          {/* <ErrorMessage name="name" component="div" className="text-danger" /> */}
        </div>
        <div className="d-flex justify-content-between mb-2">
          <label className="mr-2">Information Details:</label>
          <Field
            name="content"
            as="textarea"
            placeholder="Information Details"
            style={{ width: '50%', height: '100px' }}
            className="form-control"
          />
          {/* <ErrorMessage name="phone" component="div" className="text-danger" /> */}
        </div>
        <div className="d-flex justify-content-end mt-3">
          <Button color="primary"  style={{ backgroundColor: "#2F8C47", width: '50%'  }} type="submit" disabled={isAddInformationLoading}>
            {isAddInformationLoading ? (
              <span>Loading...</span>
            ) : (
              <>
                <i className="fa fa-plus mr-2" aria-hidden="true"></i> Add Information
              </>
            )}
          </Button>
        </div>
      </Form>
    )}
  </Formik>
  );
}

InfoCreateFrom.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default InfoCreateFrom;
